// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".routeBlockManager[data-v-f8579006]{\n  border-top-right-radius: 8px;\n  border-top-left-radius: 8px;\n  border-top: 0.5px solid transparent;\n  -webkit-box-shadow: 0px -4px 18px 0px rgba(0, 0, 0, 0.05);\n          box-shadow: 0px -4px 18px 0px rgba(0, 0, 0, 0.05);\n}\n", ""]);
// Exports
module.exports = exports;
